module.exports = __webpack_public_path__ + "static/2-0404c4aabeeb597119568d4584ec89fc.jpg";